Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.ImageContentFactory

  create: (socialContent, allTags) ->
    return new Monitoring.Models.SocialContents.ImageContent(socialContent).set({ possibleTags: allTags })

  canHandle: (socialContent) ->
    #TODO: Define the canHandle  method when the social content gets defined
    false
